<template>
  <nav id="header" class="fixed w-full z-30 top-0 text-white bg-white">

	<div class="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">

		<div class="pl-4 flex items-center">
			<router-link class="toggleColour text-black no-underline hover:no-underline font-bold text-2xl lg:text-4xl"  :to="{'name': 'home'}">
        Carina Landin
				<p class="text-black text-sm">carina@carinalandin.se</p>
				<p class="text-black text-sm italic">Stockholm</p>
			</router-link>
		</div>

		<div class="block lg:hidden pr-4">
			<button id="nav-toggle" class="flex items-center p-1 text-orange-800 hover:text-gray-900">
				<svg class="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
			</button>
		</div>

		<div class="w-full flex-grow lg:flex lg:items-center lg:w-auto hidden lg:block mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20" id="nav-content">
			<ul class="list-reset lg:flex justify-end flex-1 items-center">
				<!--
				<li class="mr-3">
					<router-link class="inline-block py-2 px-4 text-black font-bold no-underline" to="sida1">Sida 1</router-link>
				</li>
				<li class="mr-3">
					<router-link class="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="sida2">Sida 2</router-link>
				</li>
				<li class="mr-3">
					<router-link class="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="sida3">Sida 3</router-link>
				</li>
				-->
			</ul>
		</div>
	</div>

	<hr class="border-b border-gray-100 opacity-25 my-0 py-0" />
</nav>
</template>

<script>
export default {

}

</script>

<style>

</style>
